import { Facebook, Instagram, Twitter } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="text-muted-foreground">Email: support@pharmacare.com</li>
              <li className="text-muted-foreground">Phone: +234 123 456 7890</li>
              <li className="text-muted-foreground">Hours: Mon-Fri 8am-6pm WAT</li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">Address</h3>
            <p className="text-muted-foreground">
              123 Healthcare Avenue<br />
              Victoria Island<br />
              Lagos, Nigeria
            </p>
          </div>
          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-muted-foreground hover:text-foreground">Privacy Policy</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground">Terms of Service</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground">Refund Policy</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t mt-12 pt-8 text-center text-sm text-muted-foreground">
          <p>© 2024 PharmaCare. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}